import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type MyJobsTemplateProps = {
  /** A PageHeader, with the sign-in nudge for visitors. */
  header: ReactNode;
  /** Tabs from md; on phones the TabBar takes over (pass it separately at the page level). */
  tabs?: ReactNode;
  /** "Up next" ListRows. */
  upNext?: { title: ReactNode; content: ReactNode };
  /** KanbanLanes on desktop, the stage-chip list on phones (or, for searches and alerts, a Readout and toggle ListRows). */
  children: ReactNode;
  /** The job Sheet opened on click. */
  sheet?: ReactNode;
  className?: string;
};

/** The My Jobs hub and every tool route (saved, applied, searches, alerts, watchlist). */
export function MyJobsTemplate({ header, tabs, upNext, children, sheet, className }: MyJobsTemplateProps) {
  return (
    <PageContainer width="wide" className={className}>
      <div className="flex flex-col gap-jc-block py-jc-block pb-24">
        {header}
        {tabs ? <div className="hidden md:block">{tabs}</div> : null}
        {upNext ? (
          <TemplateSection id="up-next" title={upNext.title}>
            {upNext.content}
          </TemplateSection>
        ) : null}
        {children}
        {sheet}
      </div>
    </PageContainer>
  );
}
